import { Injectable, Pipe } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { NoteModel } from '../models/note.model';
// tslint:disable-next-line:use-pipe-transform-interface
@Pipe({ name: 'NoteService' })

@Injectable()
export class NoteService {
  constructor(private httpClient: HttpClient) { }

  // Create note
  createNote(noteModel: NoteModel, leadId: string, fileList: File[], userId: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/note/createNote';
    let formData: FormData = new FormData();
    if (fileList !== null) {
      for (var i = 0; i < fileList.length; i++) {
        formData.append("fileList", fileList[i]);
      }
    }

    formData.append("Note[Description]", noteModel.Description);
    formData.append("Note[Type]", noteModel.Type);
    formData.append('Note[NoteTitle]', noteModel.NoteTitle);
    formData.append('LeadId', leadId);
    formData.append('UserId', userId);

    return this.httpClient.post(url, formData)
      .map((response: Response) => {
        return response;
      });
  }

  // Disable note
  disableNote(noteId: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/note/disableNote';
    return this.httpClient.post(url, { NoteId: noteId })
      .map((response: Response) => {
        return response;
      });
  }

  createNoteAndNoteDocument(leadId: string, fileList: File[], userId: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/note/createNoteAndNoteDocument';
    let formData: FormData = new FormData();
    for (var i = 0; i < fileList.length; i++) {
      formData.append('fileList', fileList[i]);
    }

    formData.append('LeadId', leadId);
    formData.append('UserId', userId);

    return this.httpClient.post(url, formData)
      .map((response: Response) => {
        return response;
      });
  }

  editNoteById(noteId: string, noteDescription: string, fileList: File[], leadId: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/note/editNoteById';
    const formData: FormData = new FormData();
    for (let i = 0; i < fileList.length; i++) {
      formData.append('FileList', fileList[i]);
    }
    formData.append('LeadId', leadId);
    formData.append('NoteId', noteId);
    formData.append('NoteDescription', noteDescription);

    return this.httpClient.post(url, formData)
      .map((response: Response) => {
        return response;
      });
  }

  searchNote(keyword: string, fromDate: Date, toDate: Date, leadId: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/note/searchNote';
    return this.httpClient.post(url, { Keyword: keyword, FromDate: fromDate, ToDate: toDate, LeadId: leadId })
      .map((response: Response) => {
        return response;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/note.service.ts